import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Pollsandsurvey } from 'src/app/model/pollsandsurvey.model';
import { PollsandsurveyService } from 'src/app/services/pollsandsurvey.service';
import { SurveyReminderSuccessComponent } from 'src/app/modal/survey-reminder-success/survey-reminder-success.component';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'app-send-survey-reminder',
  templateUrl: './send-survey-reminder.component.html',
  styleUrls: ['./send-survey-reminder.component.scss'],
})
export class SendSurveyReminderComponent implements OnInit {

  public pollsandsurvey = new Pollsandsurvey();

  @Input() id: string;
  @Input() surveyId: string;
  @Input() reminderMessage: string;

  myForm = new FormGroup({
    reminderMessage: new FormControl(),
    //surveyId: new FormControl(),
  });

  finalSubmissionArray = [];
  isEditNote: boolean = true;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private pollsandsurveyService: PollsandsurveyService,
    private modalService: NgbModal,
  ) {
    this.myForm = this.formBuilder.group({
      reminderMessage: [this.reminderMessage, [Validators.maxLength(500), Validators.required]],
      //surveyId: this.surveyId
    });
  }

  ngOnInit(): void {
    this.pollsandsurvey.reminderMessage = this.reminderMessage;
    if (this.pollsandsurvey.reminderMessage == undefined || this.pollsandsurvey.reminderMessage == 'undefined') {
      this.pollsandsurvey.reminderMessage = '';
      this.isEditNote = false;
    }
    console.log(this.pollsandsurvey.reminderMessage);
  }

  onSubmit(): void {
    this.finalSubmissionArray = [];
    if (this.myForm.valid) {
      this.finalSubmissionArray.push({
        "reminderMessage": this.myForm.value.reminderMessage,
        "SurveyId": this.surveyId
      });
      console.log(this.myForm.value);
      this.pollsandsurveyService
        .sendReminderToNon(this.finalSubmissionArray[0])
        .subscribe((res) => {
          this.modal.dismiss();
          this.openModal();
          //location.reload();
        });

    } else {
      this.myForm.markAllAsTouched();
    }
  }

  openModal(): void {

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(SurveyReminderSuccessComponent, modalOptions);
  }

  editNote() {
    this.isEditNote = false;
  }
}
